import components from '../components';
import NotreActionController from './notre-action.controller';
import NotreActionTemplate from './notre-action.template.html';

components
  .component('notreAction', {
    bindings: {
      comment: '@'
    },
    controller: NotreActionController,
    template: NotreActionTemplate
  });



// WEBPACK FOOTER //
// ./src/app/components/notre-action/notre-action.component.js